import React from 'react';
import { matchPath } from 'react-router-dom';
import { AlertTriangle } from 'react-feather';
import Text, { TEXT_VARIANTS } from 'components/ui/Typography/Text';

const LaunchScormError = () => {
  const isPreviewing = !!matchPath(window.location.pathname, {
    path: '/preview/',
  });

  const errorMessage = isPreviewing
    ? t('questions.types.elearning.file_upload.error.creator_launch_error')
    : t('questions.types.elearning.file_upload.error.learner_launch_error');

  return (
    <div className="LaunchScormError-container">
      <AlertTriangle className="c-midnight-50" size={48} />
      <Text variant={TEXT_VARIANTS.TITLE_BOLD} className="pt-24">
        Content not available
      </Text>
      <Text
        variant={TEXT_VARIANTS.BODY}
        className="LaunchScormError-errorMessage pt-4"
      >
        {errorMessage}
      </Text>
    </div>
  );
};

export default LaunchScormError;
